module.exports = __webpack_public_path__ + "static/media/printableVer.e2536e52.png";